import React from 'react'
import { observer, inject } from 'mobx-react'
import { ComponentExt } from '../../../util/reactExt'
import { Pagination, Carousel, message } from 'antd'
import VideoNavigation, { categoryItem } from '../../shared/VideoNavigation'
import Cate from '../../../components/layout/CateLayout'
import Card from '../../../components/Card'
import { RouteComponentProps } from '../../../../node_modules/@types/react-router'
import { isNil, get } from 'lodash'
import styles from './style.scss'

interface IProps extends RouteComponentProps<any> {
  globalStore: IGlobalStore.GlobalStore
  userStore: IUserStore.UserStore
}

interface IState {
  pageindex: number
  tagIndex: number
  videoCategoryNavList: categoryItem[]
  newhotlist: any[]
  newhottotal: number
  hotLoading: boolean
  newCourseList: any[]
  newLoading: boolean
  bannerList: any[]
}

@inject('globalStore', 'userStore')
@observer
class Home extends ComponentExt<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      pageindex: 1,
      tagIndex: 0,
      videoCategoryNavList: [],
      newhotlist: [],
      newhottotal: 0,
      hotLoading: true,
      newCourseList: [],
      newLoading: true,
      bannerList: [],
    }
  }

  componentDidMount() {
    this.getBannerList()
    this.fetchCategroyNavList()
    this.fetchIndexList(0)
    this.fetchNewCourse()
  }

  async getBannerList() {
    const { code, msg, response } = await this.api.home.getBannerList({
      position_id: 107,
    })

    if (code === 1) {
      this.setState({ bannerList: get(response, 'pds', []) })
    } else {
      message.error(msg)
    }
  }

  async fetchCategroyNavList() {
    const storeData = localStorage.getItem(`videoCategoryNavList`)
    let data: categoryItem[]

    if (!isNil(storeData)) {
      data = JSON.parse(storeData)
    } else {
      data = (await this.api.home.getNavCategoryList()).slice(0, 4)
      localStorage.setItem(`videoCategoryNavList`, JSON.stringify(data))
    }

    this.setState({
      videoCategoryNavList: data,
    })
  }

  async fetchIndexList(idx, pageindex = 1) {
    const {
      home: { getHotList, getPersonalList, getPermList },
      user: { getUserStudyHistoryList },
    } = this.api
    try {
      const { data, total } = await [
        getPermList,
        getPersonalList,
        getUserStudyHistoryList,
      ][idx]({
        pagesize: 10,
        pageindex,
      })
      this.setState({ newhotlist: data, newhottotal: total, hotLoading: false })
    } catch (err) {
      console.error(err)
    }
  }

  async fetchNewCourse() {
    const { data } = await this.api.home.getNewCourse()

    if (data.length > 0) {
      this.setState({
        newCourseList: data,
        newLoading: false,
      })
    }
  }

  onClickBanner = i => {
    const { jump_type, jump_params } = i
    const { id, url, live_code } = jump_params
    if (jump_type === 0) {
      return
    }
    const urlList = {
      1: `https://gsh.n8n8.cn/viewpoint/${id}`, // 观点文章
      2: `https://gsh.n8n8.cn/circles/home/${id}`, // 投顾详情（就是圈子首页）
      3: `https://gsh.n8n8.cn/circles/live/${id}`, // 投顾直播间
      4: url, // 网页
      5: 'https://gsh.n8n8.cn/ask', // 问答列表，无跳转参数
      7: `https://toujiao.n8n8.cn/live/${live_code}`, // 投教视频直播间
      13: `https://toujiao.n8n8.cn/playback/${id}`, // 录播回放
      14: `https://toujiao.n8n8.cn/introduce/${id}`, // 投教课程详情
      15: `https://neican.n8n8.cn/details/strategy/${id}`, // 经选内参 - 策略文章
      16: `https://neican.n8n8.cn/pc/special/${id}`, // 经选内参 - 专题
      17: 'https://gsh.n8n8.cn/circle', // 投顾模块首页，无跳转参数
      18: 'https://gsh.n8n8.cn/ask', // 投顾提问页，无跳转参数
      20: `http://passport.n8n8.cn/register/?from=${window.location.href}`, // 登录页，无跳转参数
    }
    const path = urlList[jump_type]

    path && window.open(url)
  }

  fetchList(id) {
    return this.api.home.getCategoryList(id, { pageindex: 1 })
  }

  handleCategoryListChange = (item, c0, c1, c2) => {
    if (item.loaded === true) {
      return
    }

    const { videoCategoryNavList } = this.state
    const categoryIdList = item.child.reduce((total, current) => {
      return total.concat([current.category_id])
    }, [])

    const list = categoryIdList.map(x => this.fetchList(x))

    Promise.all(list)
      .then(resolve => {
        item.loaded = true
        item.child.forEach((it, i) => {
          const response: any = resolve[i]
          if (response.type === 'category') {
            let dataArr = []
            for (const key of Object.keys(response.data)) {
              dataArr = dataArr.concat(
                []
                  .concat([{ title: `${key}`, isCategory: true }])
                  .concat(response.data[key]),
              )
            }
            it.child = dataArr
          } else {
            it.child = response.data
          }
        })
        videoCategoryNavList[c0].child[c1].child[c2] = item

        localStorage.setItem(
          `videoCategoryNavList`,
          JSON.stringify(videoCategoryNavList),
        )
        this.setState({
          videoCategoryNavList,
        })
      })
      .catch(err => {
        this.$message.error('加载失败，请重试')
      })
  }

  toDetail = (id, type, content?) => {
    if (type === '1000104') {
      return window.open(`#/topicdetail/${id}`, '_blank')
    }
    if (type === '1000105') {
      return window.open(content, '_blank')
    }
    window.open(`#/course/${id}?type=${type}`)
  }

  handleTab = (_, val) => {
    this.setState({
      tagIndex: val,
      pageindex: 1,
      hotLoading: true,
      newhotlist: [],
    })
    this.fetchIndexList(val)
  }

  pageChange = page => {
    const { tagIndex: id } = this.state
    this.setState({
      pageindex: page,
    })
    window.scrollTo(0, 780)
    this.fetchIndexList(id, page)
  }

  render() {
    const {
      tagIndex,
      hotLoading,
      videoCategoryNavList,
      newhotlist,
      newhottotal,
      pageindex,
      newCourseList,
      bannerList,
    } = this.state

    return (
      <div className={styles.home}>
        {bannerList.length > 0 && (
          <section className={styles.carousel}>
            <Carousel effect="fade" autoplay>
              {bannerList.map((i: any) => (
                <div
                  key={i.id}
                  onClick={() => {
                    this.onClickBanner(i)
                  }}
                >
                  <img
                    src={i.show_content.image_url}
                    alt={i.title}
                    style={{ cursor: i.jump_type ? 'pointer' : 'initial' }}
                  />
                </div>
              ))}
            </Carousel>
          </section>
        )}
        <section className={styles.banner}>
          <VideoNavigation
            data={videoCategoryNavList}
            handler={this.handleCategoryListChange}
            onClick={this.toDetail}
          />
        </section>
        <section>
          <div className={styles.newcourse}>
            <div className={styles.newcourseInner}>
              <div className={styles.newcourseTitle}>最新课程</div>
              <div className={styles.newcourseBody}>
                {!!newCourseList.length &&
                  newCourseList.map(({ id, title, type, content }, idx) => (
                    <div key={`nc${idx}`} className={styles.newcourseItem}>
                      <div
                        className={styles.newcourseItemInner}
                        onClick={() => this.toDetail(id, type, content)}
                      >
                        <div className={styles.newcourseItemTitle}>{title}</div>
                        <div className={styles.newcourseItemTag}>
                          <span>
                            {
                              ['课件', '视频', '文章', '音频', '专题', '外链'][
                                [
                                  '1000101',
                                  '1000102',
                                  '1000103',
                                  '1000104',
                                  '1000105',
                                ].indexOf(type) + 1
                              ]
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </section>
        <div style={{ paddingTop: 20 }}>
          <Cate
            title="猜你喜欢"
            leftTabs={['权限推荐', '个性推荐', '上次学习记录']}
            index={tagIndex}
            tabChange={this.handleTab}
            loading={hotLoading}
          >
            {newhotlist &&
              newhotlist.map(
                (
                  {
                    id,
                    img_url,
                    title,
                    view_count,
                    course_time,
                    type,
                    content,
                  },
                  idx,
                ) => (
                  <Card
                    key={`fccard-${idx}`}
                    dataType={type}
                    cover={img_url}
                    title={title}
                    watch={view_count}
                    time={course_time}
                    onClick={() => this.toDetail(id, type, content)}
                  />
                ),
              )}
          </Cate>
          <div style={{ textAlign: 'center' }}>
            <Pagination
              hideOnSinglePage={true}
              total={newhottotal}
              current={pageindex}
              onChange={this.pageChange}
              defaultPageSize={16}
            />
          </div>
        </div>
      </div>
    )
  }
}
export default Home
